// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";

export const Container = styled.div<{variant: "document" | "html" }>`
    height: calc(100% - 134px);
    margin-top: 134px;

    object {
        height: 100%;
        width: 100%;
    }
`;